import { render, staticRenderFns } from "./216.vue?vue&type=template&id=5087a92a&scoped=true&"
var script = {}
import style0 from "./216.vue?vue&type=style&index=0&id=5087a92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087a92a",
  null
  
)

export default component.exports